import delovnicas from '@/api/arhiv'

export default {
  namespaced: true,

  actions: {

    async addUserWorkTime ({ rootState }, { user, startTime, startDate, startExchange, stopDate, stopTime, stopExchange, start_id, stop_id }) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
      /*
        {
          user,
          action,
          exchange,
          action_time
          start_id,
          stop_id,
        }
      */
    //   yyyy-MM-ddThh:mm:ss
      console.log(stopDate, stopTime)
      var inserStartPromise = null
      var inserStopPromise = null

      if (startExchange && startDate) {
        inserStartPromise = {
          user: start_id ? null : user,
          action: 1,
          exchange: startExchange,
          action_time: `${startDate}T${startTime}`,
          id: start_id
        }
      }
      if (stopExchange && stopDate) {
        inserStopPromise = {
          user: stop_id ? null : user,
          action: 2,
          exchange: stopExchange,
          action_time: `${stopDate}T${stopTime}`,
          id: stop_id
        }
      }
      console.log(inserStartPromise, inserStopPromise)
      if (inserStartPromise) {
        await delovnicas.addUserWorkTime({ businessUnitId, data: inserStartPromise })
      }
      if (inserStopPromise) {
        await delovnicas.addUserWorkTime({ businessUnitId, data: inserStopPromise })
      }
      return
    },

    async removeUserWorkTime ({ rootState }, workTimeId) {
      const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null

      await delovnicas.removeUserWorkTime({ businessUnitId, workTimeId })
      return
    },

    generirajPrikazDC ({ commit }, params) {
      const apiParams = {}
      if (params.user) {
        apiParams.user = params.user.id
      }
      apiParams.dateFrom = `${params.startDate}T00:00:00`
      apiParams.dateTo = `${params.endDate}T23:59:59`

      apiParams.businessUnitId = params.businessUniId

      return new Promise((resolve, reject) => {
        console.log('send reqq:')
        delovnicas.generirajPrikazDC(apiParams)
          .then(response => {
            response = response.data && response.data.items ? response.data.items[0] : { totals: [], daily: [] }
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    currentSessionWorkTime ({ commit }, params) {
      const apiParams = {}
      if (params.user) {
        apiParams.user = params.user.id
      }
      apiParams.dateFrom = `${params.startDate}T00:00:00`
      apiParams.dateTo = `${params.endDate}T23:59:59`

      apiParams.businessUnitId = params.businessUniId

      return new Promise((resolve, reject) => {
        delovnicas.currentSessionWorkTime(apiParams)
          .then(response => {
            response = response.data && response.data.items ? response.data.items[0] : { totals: [], daily: [] }
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    statusDelovnegaCasa ({ rootState }, status) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        delovnicas.statusDelovnegaCasa({ businessUnitId, status })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },

    statusDelovnegaCasaDistributer ({ commit, rootState }, { businessUnitId, status, headers }) {
      return new Promise((resolve, reject) => {
        delovnicas.statusDelovnegaCasa({ businessUnitId, status, headers })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    }
  }
}
